<div class="card">
    <app-header titulo="Apontamentos" descricao="Apontamentos de abastecimentos e lubrificantes."></app-header>

    <p-table [value]="apontamentos" 
       dataKey="id" 
       [loading]="loading" 
       [resizableColumns]="true" 
       [tableStyle]="{'font-size':'.9rem', 'font-weight':'400', 'border-spacing':'0 0 !important', 'border-colapse': 'separate'}"  
       #dt 
       [globalFilterFields]="['instancia','noOrdem','cdProdutoErp','deProduto','deTransportadora','deDestinatario','fgStatusInteg']" 
       styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines" 
       [rowsPerPageOptions]="[20, 50, 100]" 
       [paginator]="true" 
       [rows]="20" 
       [totalRecords]="totalRegistros"
       [showCurrentPageReport]="true" 
       currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros" 
       [scrollable]="true" 
       scrollHeight="40.5rem"
       [lazy]="true"
       (onLazyLoad)="buscarApontamentos($event)"
       (onPage)="buscarApontamentos($event)">
        <ng-template pTemplate="caption">
            <div class="flex">
                <button pButton pRipple icon="pi pi-refresh" (click)="atualizar()"></button>
                <span class="p-input-icon-left ml-auto">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($any($event.target)?.value, 'contains')" placeholder="Pesquisar" />
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th>Instância</th>
                <th>Módulo
                    <p-columnFilter field="modulo" matchMode="in" display="menu" [showApplyButton]="false" [showClearButton]="false" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">

                        
                        
                        <ng-template pTemplate="filter" let-value let-filter="filterCallback" >
                            <p-dropdown 
                            [options]="modulos" 
                            [(ngModel)]="modulosSelecionados"
                            optionLabel="nome"
                            
                            [showClear]="true"
                            placeholder="Selecione um módulo" 
                            styleClass="w-20rem"
                            (onChange)="filter($event.value)">
                            </p-dropdown>
                        </ng-template>

                        <ng-template pTemplate="clearfiltericon">

                        </ng-template>
                    </p-columnFilter>
                </th>
                <th>Boletim</th>
                <th>Sequência</th>
                <th>Data Operação</th>
                <th>Hora Operação</th>
                <th>Material</th>
                <th>Quantidade</th>
                <th>Valor Unitário</th>
                <th>Ação</th>
                <th>Boletim PIMS</th>
                <th>Sequência PIMS</th>
                <th>Status</th>
                <th>Data Recebimento</th>
                <th>Data Integração PIMS</th>
                <th>Mensagem</th>
                <th></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-apontamento>
            <tr>
                <td>{{ apontamento.instancia }}</td>
                <td>{{ apontamento.moduloOrigem }}</td>
                <td>{{ apontamento.boletimSisma }}</td>
                <td>{{ apontamento.sequenciaSisma }}</td>
                <td>{{ apontamento.dataOperacao | date: "dd/MM/yyyy" }}</td>
                <td>{{ apontamento.horaOperacao }}</td>
                <td>{{ apontamento.material }}</td>
                <td>{{ apontamento.quantidade }}</td>
                <td>{{ apontamento.valorUnitario }}</td>
                <td>{{ apontamento.acao }}</td>
                <td>{{ apontamento.boletimPims }}</td>
                <td>{{ apontamento.sequenciaPims }}</td>
                <td><app-tag-status [status]="apontamento.status"></app-tag-status></td>
                <td>{{ apontamento.dataRecebimento | date: "dd/MM/yyyy HH:mm:ss"}}</td>
                <td>{{ apontamento.dataIntegracaoPims | date: "dd/MM/yyyy HH:mm:ss" }}</td>
                <td>{{ apontamento.mensagem }}</td>

                <!-- <td><span (click)="exibirJson(apontamento)" style="cursor: pointer; color: darkblue;">Dados</span></td> -->
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <td colspan="10">Nenhum registro encontrado</td>
        </ng-template>
    </p-table>
</div>